import React from 'react'

import { withMicrocopy } from '~contexts/MicrocopyContext'
import Message from '~components/Message'
import Parameters from '~components/Parameters'
import style from './Variant.module.scss'

const Variant = ({
  variant,
  selected,
  onToggle,
  id,
  params,
  microcopy
}) => (
  <>
    <div
      id={id}
      className={style.toggle} 
      data-show={selected}
      onClick={onToggle}
    >
      { microcopy.text(`reference.resource_variants.${variant}`) }
    </div>
    { selected && (
      <>
        <Message size='small' noMargin>
          <div dangerouslySetInnerHTML={{
            __html: microcopy.text(`messages.resource_variant_descriptions.${variant}`) 
          }} />
        </Message>
        <Parameters hideExtras params={params} />
      </>
    )}
  </>
)

export default withMicrocopy(Variant)